// VT-14: keeps the pack sub-label inside the quantity pill in step with the number.
// Delegated on document because Dawn's QuantityInput dispatches a bubbling `change`
// on every +/- click and typing fires it natively — one listener covers both paths.
document.addEventListener('change', (event) => {
  const label = event.target.closest?.('.quantity__value')?.querySelector('.quantity__pack-label');
  if (!label) return;
  const packs = Math.round(event.target.value / (Number(label.dataset.step) || 1));
  label.hidden = packs < 2;
  label.textContent = label.dataset.template.replace('999', packs);
});
